import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  policyBeingEdited: null,
  policies: [],
  isLoading: false,
  error: null,
};

export const privacyPolicySlice = createSlice({
  name: "privacyPolicy",
  initialState,
  reducers: {
    setPolicyBeingEdited: (state, action) => {
      state.policyBeingEdited = action.payload;
    },
    clearPolicyBeingEdited: (state) => {
      state.policyBeingEdited = null;
    },
    setPolicies: (state, action) => {
      state.policies = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPrivacyPolicyLoading: (state, action) => {
      state.isLoading = action.payload;
      state.error = null;
    },
    setPrivacyPolicyError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    addPolicy: (state, action) => {
      state.policies.push(action.payload);
    },
    updatePolicy: (state, action) => {
      const updatedPolicy = action.payload;
      const index = state.policies.findIndex(
        (p) => p._id === updatedPolicy._id
      );
      if (index !== -1) {
        state.policies[index] = { ...state.policies[index], ...updatedPolicy };
      }
    },
    deletePolicy: (state, action) => {
      const id = action.payload;
      state.policies = state.policies.filter((p) => p._id !== id);
    },
    clearAllPrivacyPolicies: (state) => {
      state.policyBeingEdited = null;
      state.policies = [];
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const {
  setPolicyBeingEdited,
  clearPolicyBeingEdited,
  setPolicies,
  setPrivacyPolicyLoading,
  setPrivacyPolicyError,
  addPolicy,
  updatePolicy,
  deletePolicy,
  clearAllPrivacyPolicies,
} = privacyPolicySlice.actions;

export default privacyPolicySlice.reducer; // This is the default export
